export function getMimeType(type: string): string {
  switch (type) {
    case 'xlsx':
      return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    default:
      return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  }
}

export const getBase64MimeType = (encoded: string) => {
  if (typeof encoded !== 'string') {
    return null
  }

  const mime = encoded.match(/data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+).*,.*/)

  if (mime && mime.length) {
    return mime[1]
  }

  return null
}
